module.exports = __webpack_public_path__ + "img/bglogo.ec03f1b8.png";